import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { ReligionBranch } from '../components/religion-branch/religion-branch.component';

@Injectable()
export class LectionarySourceService {

  private cache: LectionarySource[];

  constructor(private apiSvc: ApiService) { }

  public loadEntites(): Promise<LectionarySource[]> {

    const p = new Promise<LectionarySource[]>((resolve, reject) => {
 
      if (this.cache && this.cache.length > 0) {
        console.log("LectionarySource cache detected");
        resolve(this.cache);
        return;
      }

      this.apiSvc.get("api/LectionarySource/name", null).subscribe(
        (data: LectionarySource[]) => {
          console.log(data);
          this.cache = data;
          resolve(this.cache);
        },
        (err) => {
          console.log("error", err);
        }
      );

  });

  return p;

}

public getItem(itemId: number): Promise<LectionarySource> {

  const p = new Promise<LectionarySource>((resolve, reject) => {

    this.apiSvc.get("api/LectionarySource/GetItem/" + itemId, null).subscribe(
      (data: LectionarySource) => {
        console.log("lectionaryitem/GetItem", data);
        resolve(data);
      },
      (err) => {
        console.log("error", err);
      }
    );

  });

  return p;
}

  public save(model: LectionarySource): Promise<LectionarySource> {

    const p = new Promise<LectionarySource>((resolve, reject) => {

      this.apiSvc.post("api/lectionarySource/save", model).subscribe(
        (data: LectionarySource) => {
            resolve(data);
        },
        (err) => {
          console.log("error", err);
        //  this.isLoading = false;
        }
      );

    });

  return p;
  }
}

export class LectionarySource {
  Id: number;
  Name: string;
  NameAbbreviated: string;
  Description: string;
  ReligionBranch: ReligionBranch;
  CopyrightYear: number;
  CopyrightNote: string;
  CopyrightText: string;
  ShowPageNumbers: boolean;
  IsActive: boolean;
}
